import { useEffect, useRef, useState } from "react"
import axios from "axios";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Typography, Alert, List, ListItem } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { API_URL, NWIS_API_URL } from "../../config/config.data";
import { parseNwisTsv } from "../../utils";
import sites from "../../config/entities/entity.sites";
import datums from "../../config/entities/entity.datums";

export const AddNwisRecord = () => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [textBoxValue, setTextBoxValue] = useState("");

  const handleSetTextBoxValue = (e) => setTextBoxValue(e.target.value);

  // useRef to make sure the timerQueue state is up to date in any functions that use it
  const [timerQueue, setTimerQueue] = useState([]);
  const snackbarRef = useRef(timerQueue);
  snackbarRef.current = timerQueue;

  useEffect(() => {
    return () => timerQueue.forEach(({ timerId }) => clearTimeout(timerId));
  }, []);

  const enqueue = (id) => {
    const timerId = setTimeout(dequeue, 3000, id);
  };

  const dequeue = (id) => setTimerQueue((queue) => queue.filter((el) => el.site_number !== id));

  const handleAddNWISRecord = () => {
    setDialogOpen(false);
    const siteNumbers = textBoxValue;
    axios.get(NWIS_API_URL(siteNumbers))
      .then((response) => {
        axios.get(`${API_URL}/${datums.endpoint}`)
          .then((datumResponse) => {
            const siteList = siteNumbers.split(",")
            for (let i = 0; i < siteList.length; i++) {
              const data = parseNwisTsv(response.data);
              // NWIS API returns an additional row before the actual data, so index of i+1 is used when accessing the API data
              const datumId = datumResponse.data.datums.filter((d) => d.name === data.coord_datum_cd[i + 1])[0]?.id;
              const body = {
                name: data.station_nm[i + 1],
                site_number: siteList[i],
                station_name: data.station_nm[i + 1],
                datum: data.coord_datum_cd[i + 1],
                nwis_site_url: `https://waterdata.usgs.gov/monitoring-location/${siteList[i]}/`,
                latitude: data.dec_lat_va[i + 1],
                longitude: data.dec_long_va[i + 1],
                datum_id: datumId,
              }
              axios.post(`${API_URL}/${sites.endpoint}`, body)
                .then((postResponse) => {
                  const messages = snackbarRef.current;
                  if (postResponse.status === 200) {
                    setTimerQueue([...messages, { "message": `Site ${siteList[i]} added successfully`, "severity": "success", "site_number": siteList[i] }]);
                    enqueue(siteList[i])
                  } else {
                    setTimerQueue([...messages, { "message": `Site ${siteList[i]} failed to add`, "severity": "error", "site_number": siteList[i] }]);
                    enqueue(siteList[i])
                  }
                })
            }
          })
      })
  }

  return (
    <div>
      <Button
        variant="outlined"
        startIcon={<AddIcon />}
        onClick={() => setDialogOpen(true)}
        sx={{
          color: "primary.contrastText",
          borderColor: "primary.dark",
          "&:hover": {
            borderColor: "primary.dark",
          },
        }}
      >
        Add NWIS Record
      </Button>
      <Dialog
        maxWidth="xs"
        TransitionProps={{ onEntered: () => { } }}
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
      >
        <DialogTitle>Add NWIS Record</DialogTitle>
        <DialogContent dividers>
          <Typography>Enter NWIS Site Number:</Typography>
          <TextField
            size="small"
            type="text"
            variant="outlined"
            value={textBoxValue}
            onChange={handleSetTextBoxValue}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)} color="secondary">
            Cancel
          </Button>
          <Button
            onClick={handleAddNWISRecord}
            color="secondary"
            disabled={textBoxValue.split(',').some(isNaN)}
            sx={{
              fontWeight: "bold",
              "&.Mui-disabled": {
                color: "primary.dark",
              },
            }}
          >
            Add Site
          </Button>
        </DialogActions>
      </Dialog>
      <List
        sx={{
          position: "fixed",
          bottom: 0,
          right: 0,
          margin: "1rem",
          zIndex: 9999,
        }}
      >
        {timerQueue && timerQueue.map((alert, index) =>
          <ListItem>
            <Alert
              severity={alert.severity}
              sx={{
                position: "relative",
                bottom: `${index}rem`,
                right: 0,
                margin: "0.5rem",
              }}
            >
              {alert.message}
            </Alert>
          </ListItem>
        )}
      </List>
    </div>
  )
}